module.exports = __webpack_public_path__ + "static/img/rotation_1.937bbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/service/rotation_1.png
// module id = s08K
// module chunks = 1